import './DashboardPage.css';
import React, { useEffect, useRef } from 'react';
// import { Input, Form } from 'antd';
// import * as AntDIcons from '@ant-design/icons';
// import SideCalendar from '../side-calendar/SideCalendar'; //'./side-calendar/SideCalendar';
// import NoticeBoard from '../notice-board/NoticeBoard';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
   ArrowRightOutlined,
   BookOutlined,
   CalendarOutlined,
   FileTextOutlined,
   HistoryOutlined,
   PlayCircleOutlined,
   ReloadOutlined,
   VideoCameraOutlined,
} from '@ant-design/icons';
// import SimpleBarReact from "simplebar-react";
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import NoticeBoardSlide from '../notice-board/NoticeBoardSlide';
import { Button, Modal, Tooltip, Typography, Image } from 'antd';
import { useConfigSettings } from '../side-menu/useSideMenu';
import { ChatGPT } from '../chatGPT/chatGPT';
import { Grid } from 'antd';

const { Text } = Typography;

function Dashboard() {
   const navigate = useNavigate();
   const [currentUsername, setCurrentUsername] = React.useState('');
   const [currentCount, setCurrentCount] = React.useState(0);
   const [upcomingCount, setUpcomingCount] = React.useState(0);
   const [pastCount, setPastCount] = React.useState(0);
   const [homeworkSnapshot, setHomeworkSnapshot] = React.useState({
      subjects: 0,
      total: 0,
      notSubmitted: 0,
      forEvaluation: 0,
      returned: 0,
      dueToday: 0,
      overdue: 0,
   });

   const [checkingStudentLiveClassRooms, setCheckingStudentLiveClassRooms] =
      React.useState(false);
   const [studentLiveClassRooms, setStudentLiveClassRooms] = React.useState([]);
   const [
      joiningStudentLiveClassSectionId,
      setJoiningStudentLiveClassSectionId,
   ] = React.useState(null);
   const [visibleAI, setVisibleAI] = React.useState(false);
   const liveClassStatusRequestInFlight = useRef(false);
   const liveClassJoinInFlight = useRef(false);

   const o2o_mode = Utils.determineOnlineOffline();
   const { hasBraineeConference } = useConfigSettings();

   var role = Utils.getCurrentUserInfo(Enums.UserInfo.role);
   const userId = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const showStudentLiveClass = role === 'Student' && hasBraineeConference;
   const screens = Grid.useBreakpoint();
   const isMobile = !screens.md; // treat < md as mobile

   useEffect(() => {
      Utils.verifyJwt();
      let fullname = Utils.getCurrentUserInfo(Enums.UserInfo.fullname);
      setCurrentUsername(fullname.trim() === '' ? 'Parent' : fullname);
      // Utils.getCurrentUserInfo(Enums.UserInfo.role);
      getLessonCount();
      getHomeworkSnapshot();
   }, []);

   useEffect(() => {
      if (!showStudentLiveClass) return;

      getStudentLiveClassStatus();
   }, [showStudentLiveClass]);

   const getLessonCount = () => {
      let user = Utils.getCurrentUserInfo(Enums.UserInfo.id);
      let role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

      const root = `${process.env.REACT_APP_LMS_API}api/Lesson/lessonCount`;
      const url = root + `?userid=${user}&role=${role}`;
      console.log(url);

      console.log('loading');
      axios.get(url).then(
         (response) => {
            console.log(response);

            if (response.data) {
               const data = response.data;
               console.log(data);
               setPastCount(data.past);
               setCurrentCount(data.current);
               setUpcomingCount(data.future);
               // setData(response.data);
               // setDataContainer(response.data);
            }
         },
         (error) => {
            console.log(error.message);
            console.log('stop loading');
         }
      );
   };

   const getSubdomain = () => {
      var host = window.location.host;
      var subdomain = host.split('.')[0];
      if (subdomain.indexOf('localhost') !== -1) subdomain = 'localhost';

      return subdomain;
   };

   const openLiveClassWindow = (url) => {
      const liveClassWindow = window.open(url, '_blank');

      if (liveClassWindow) {
         liveClassWindow.opener = null;
         return;
      }

      Modal.error({
         title: 'Brainee Live Class',
         content:
            'Unable to open Brainee Live Class. Please allow pop-ups and try again.',
         centered: true,
      });
   };

   const getCsvList = (value) => {
      if (Array.isArray(value)) {
         return value.map((item) => `${item}`.trim()).filter(Boolean);
      }

      return `${value || ''}`
         .split(',')
         .map((item) => item.trim())
         .filter(Boolean);
   };

   const getStudentLiveClassRooms = (studentInfo) => {
      const gradeLevelId = studentInfo?.grade_level;
      const gradeLevelName = studentInfo?.grade_level_name;
      const sectionIds = getCsvList(studentInfo?.section);
      const sectionNames = getCsvList(studentInfo?.section_name);

      return sectionIds.map((sectionId, index) => {
         const sectionName = sectionNames[index] || sectionId;
         const roomName = [gradeLevelName, sectionName]
            .filter(Boolean)
            .join(' - ');

         return {
            gradeLevelId,
            sectionId,
            roomName,
         };
      });
   };

   const normalizeLiveClassStatus = (data, gradeLevelId, sectionId) => {
      const item = Array.isArray(data)
         ? data.find(
              (entry) =>
                 `${entry.grade_level_id}` === `${gradeLevelId}` &&
                 `${entry.section_id}` === `${sectionId}`
           )
         : data;

      return {
         loading: false,
         isRunning:
            item?.isRunning === true ||
            item?.isRunning === 'true' ||
            item?.running === true ||
            item?.running === 'true',
         gradeLevelId: item?.grade_level_id ?? gradeLevelId,
         sectionId: item?.section_id ?? sectionId,
         meetingId: item?.meeting_id ?? item?.meetingId,
      };
   };

   const getLiveClassRoomStatus = async (room) => {
      try {
         const statusResponse = await axios.get(
            `${process.env.REACT_APP_API_BIGBLUEBUTTON}/ismeetingrunning/picker`,
            {
               params: {
                  subdomain: getSubdomain(),
                  grade_level_id: room.gradeLevelId,
                  section_id: room.sectionId,
               },
            }
         );

         const status = normalizeLiveClassStatus(
            statusResponse.data,
            room.gradeLevelId,
            room.sectionId
         );

         return {
            ...room,
            loading: false,
            isRunning: status.isRunning,
            meetingId: status.meetingId,
         };
      } catch (error) {
         console.log(error.message);
         return {
            ...room,
            loading: false,
            isRunning: false,
            hasStatusError: true,
         };
      }
   };

   const getStudentLiveClassStatus = async () => {
      if (liveClassStatusRequestInFlight.current) {
         return;
      }

      liveClassStatusRequestInFlight.current = true;
      setCheckingStudentLiveClassRooms(true);
      setStudentLiveClassRooms((prev) =>
         prev.map((room) => ({ ...room, loading: true, hasStatusError: false }))
      );

      try {
         const studentResponse = await axios.get(
            `${process.env.REACT_APP_API_MANAGEMENT}/v2/getstudentinfo?id=${userId}`
         );
         const studentInfo = studentResponse.data;
         const gradeLevelId = studentInfo?.grade_level;
         const rooms = getStudentLiveClassRooms(studentInfo);

         if (!gradeLevelId || rooms.length === 0) {
            setStudentLiveClassRooms([]);
            return;
         }

         setStudentLiveClassRooms(
            rooms.map((room) => ({
               ...room,
               loading: true,
               isRunning: false,
               hasStatusError: false,
            }))
         );
         const roomsWithStatus = await Promise.all(
            rooms.map(getLiveClassRoomStatus)
         );
         setStudentLiveClassRooms(roomsWithStatus);
      } catch (error) {
         console.log(error.message);
         setStudentLiveClassRooms((prev) =>
            prev.map((room) => ({
               ...room,
               loading: false,
               isRunning: false,
               hasStatusError: true,
            }))
         );
      } finally {
         liveClassStatusRequestInFlight.current = false;
         setCheckingStudentLiveClassRooms(false);
      }
   };

   const joinStudentLiveClassRoom = ({ gradeLevelId, sectionId }) => {
      if (liveClassJoinInFlight.current) {
         return;
      }

      liveClassJoinInFlight.current = true;
      setJoiningStudentLiveClassSectionId(sectionId);

      const params = new URLSearchParams({
         subdomain: getSubdomain(),
         joiner_name: Utils.getCurrentUserInfo(Enums.UserInfo.fullname),
         grade_level_id: gradeLevelId,
         section_id: sectionId,
         join_as: 'attendee',
      });

      const url = `${process.env.REACT_APP_API_BIGBLUEBUTTON}/joinclass?${params.toString()}`;

      openLiveClassWindow(url);
      window.setTimeout(() => {
         setJoiningStudentLiveClassSectionId(null);
         liveClassJoinInFlight.current = false;
      }, 1000);
   };

   const renderStudentLiveClassStatus = (room) => {
      if (room.loading) {
         return (
            <Text className="home-dashboard-live-status is-checking">
               Checking...
            </Text>
         );
      }

      if (joiningStudentLiveClassSectionId === room.sectionId) {
         return (
            <Text className="home-dashboard-live-status is-running">
               Joining...
            </Text>
         );
      }

      if (room.hasStatusError) {
         return (
            <Text className="home-dashboard-live-status is-warning">
               Unable to check
            </Text>
         );
      }

      if (room.isRunning) {
         return (
            <button
               type="button"
               className="home-dashboard-live-join"
               disabled={joiningStudentLiveClassSectionId !== null}
               onClick={() => {
                  if (joiningStudentLiveClassSectionId === null) {
                     joinStudentLiveClassRoom(room);
                  }
               }}
            >
               <VideoCameraOutlined />
               Enter Class
            </button>
         );
      }

      return <Text className="home-dashboard-live-status">Not Started</Text>;
   };

   const renderStudentLiveClassRooms = () => {
      if (checkingStudentLiveClassRooms && studentLiveClassRooms.length === 0) {
         return (
            <p className="home-dashboard-card-empty">
               <Text>Checking Brainee Live Class rooms...</Text>
            </p>
         );
      }

      if (studentLiveClassRooms.length === 0) {
         return (
            <p className="home-dashboard-card-empty">
               <Text>No room found</Text>
            </p>
         );
      }

      return (
         <div className="home-dashboard-live-list">
            {studentLiveClassRooms.map((room) => (
               <div
                  key={`${room.gradeLevelId}-${room.sectionId}`}
                  className="home-dashboard-live-room"
               >
                  <Text className="home-dashboard-live-room-name">
                     {room.roomName}
                  </Text>
                  {renderStudentLiveClassStatus(room)}
               </div>
            ))}
         </div>
      );
   };

   const renderPastLessonOrLiveClass = () => {
      if (showStudentLiveClass) {
         return (
            <>
               <div className="home-dashboard-card-heading">
                  <span className="home-dashboard-card-icon">
                     <PlayCircleOutlined />
                  </span>
                  <span className="home-dashboard-card-title">
                     Brainee Live Class
                  </span>
                  <Tooltip
                     placement="left"
                     title="Check Brainee Live Class rooms"
                  >
                     <ReloadOutlined
                        spin={checkingStudentLiveClassRooms}
                        className="home-dashboard-card-refresh"
                        onClick={getStudentLiveClassStatus}
                     />
                  </Tooltip>
               </div>
               {renderStudentLiveClassRooms()}
            </>
         );
      }

      return (
         <>
            <div className="home-dashboard-card-heading">
               <span className="home-dashboard-card-icon">
                  <HistoryOutlined />
               </span>
               <span className="home-dashboard-card-title">Past Lesson</span>
            </div>
            {parseInt(pastCount) === 0 ? (
               <p className="home-dashboard-card-empty">
                  <Text>None</Text>
               </p>
            ) : (
               <p className="home-dashboard-card-link">
                  {o2o_mode === 'offline' ? (
                     <Text>
                        <b>{pastCount}</b> past lessons
                     </Text>
                  ) : (
                     <Text
                        onClick={() =>
                           navigate('/subject', { state: { activetab: '5' } })
                        }
                     >
                        View <b>{pastCount}</b> past lessons{' '}
                        <ArrowRightOutlined />
                     </Text>
                  )}
               </p>
            )}
         </>
      );
   };

   const displayName =
      role === 'Parent' && currentUsername !== 'Parent'
         ? `${currentUsername}'s parent`
         : currentUsername;

   const lessonCards = [
      {
         title: 'Current Lesson',
         label: 'active lesson(s)',
         count: currentCount,
         image: 'images/11.png',
         icon: <BookOutlined />,
         tab: '3',
         tone: 'current',
      },
      {
         title: 'Upcoming Lesson',
         label: 'upcoming lesson(s)',
         count: upcomingCount,
         image: 'images/12.png',
         icon: <CalendarOutlined />,
         tab: '4',
         tone: 'upcoming',
      },
   ];

   const homeworkProjectSnapshotCards =
      role === 'Student'
         ? [
              {
                 title: 'For Evaluation',
                 count: homeworkSnapshot.forEvaluation,
                 icon: <PlayCircleOutlined />,
                 onClick: () => navigate('/studenthomeworks/subjects'),
              },
              {
                 title: 'Not Submitted',
                 count: homeworkSnapshot.notSubmitted,
                 icon: <HistoryOutlined />,
                 onClick: () => navigate('/studenthomeworks/subjects'),
              },
              {
                 title: 'Returned',
                 count: homeworkSnapshot.returned,
                 icon: <ReloadOutlined />,
                 onClick: () => navigate('/studenthomeworks/subjects'),
              },
              {
                 title: 'Subjects',
                 count: homeworkSnapshot.subjects,
                 icon: <BookOutlined />,
                 onClick: () => navigate('/studenthomeworks/subjects'),
              },
           ]
         : [
              {
                 title: 'For Evaluation',
                 count: homeworkSnapshot.forEvaluation,
                 icon: <PlayCircleOutlined />,
                 onClick: () => navigate('/homeworksubjects'),
              },
              {
                 title: 'Due Today',
                 count: homeworkSnapshot.dueToday,
                 icon: <CalendarOutlined />,
                 onClick: () => navigate('/homeworksubjects'),
              },
              {
                 title: 'Overdue',
                 count: homeworkSnapshot.overdue,
                 icon: <HistoryOutlined />,
                 onClick: () => navigate('/homeworksubjects'),
              },
              {
                 title: 'Subjects',
                 count: homeworkSnapshot.subjects,
                 icon: <BookOutlined />,
                 onClick: () => navigate('/homeworksubjects'),
              },
              {
                 title: 'Total',
                 count: homeworkSnapshot.total,
                 icon: <FileTextOutlined />,
                 onClick: () => navigate('/homeworksubjects'),
              },
           ];

   const toSafeNumber = (value) => Number.parseInt(value, 10) || 0;

   const isSameDate = (left, right) =>
      left.getFullYear() === right.getFullYear() &&
      left.getMonth() === right.getMonth() &&
      left.getDate() === right.getDate();

   const getHomeworkSnapshot = async () => {
      if (role === 'Parent') return;

      try {
         if (role === 'Student') {
            const response = await axios.get(
               `${process.env.REACT_APP_API_HOMEWORK}/studentsubjectgroup?id=${userId}&t=homework`
            );
            const data = Array.isArray(response.data) ? response.data : [];
            const summary = data.reduce(
               (acc, item) => {
                  acc.notSubmitted += toSafeNumber(item.not_submitted);
                  acc.forEvaluation += toSafeNumber(item.submitted);
                  acc.returned += toSafeNumber(item.returned);
                  return acc;
               },
               { notSubmitted: 0, forEvaluation: 0, returned: 0 }
            );

            setHomeworkSnapshot({
               subjects: data.length,
               total:
                  summary.notSubmitted +
                  summary.forEvaluation +
                  summary.returned,
               notSubmitted: summary.notSubmitted,
               forEvaluation: summary.forEvaluation,
               returned: summary.returned,
               dueToday: 0,
               overdue: 0,
            });
            return;
         }

         const [subjectResponse, listResponse] = await Promise.all([
            axios.get(
               `${process.env.REACT_APP_API_HOMEWORK}/subjectgroup?id=${userId}&t=homework`
            ),
            axios.get(
               `${process.env.REACT_APP_API_HOMEWORK}/list?created_by=${userId}&level=&section=&subject=&type=homework`
            ),
         ]);

         const subjects = Array.isArray(subjectResponse.data)
            ? subjectResponse.data.length
            : 0;
         const list = Array.isArray(listResponse.data) ? listResponse.data : [];
         const now = new Date();

         let dueToday = 0;
         let overdue = 0;
         let forEvaluation = 0;

         list.forEach((item) => {
            const submitDate = new Date(item.submit_date);
            if (!Number.isNaN(submitDate.getTime())) {
               if (isSameDate(submitDate, now)) dueToday += 1;
               if (submitDate < now && !isSameDate(submitDate, now))
                  overdue += 1;
            }

            const submittedCount = toSafeNumber(
               item.submit_count ?? item.submitted ?? item.submission_count
            );
            const evaluatedCount = toSafeNumber(
               item.evaluation_count ?? item.evaluated ?? item.completed_count
            );
            if (submittedCount > evaluatedCount) {
               forEvaluation += submittedCount - evaluatedCount;
            }
         });

         setHomeworkSnapshot({
            subjects,
            total: list.length,
            notSubmitted: 0,
            forEvaluation,
            returned: 0,
            dueToday,
            overdue,
         });
      } catch (error) {
         console.log(error.message);
         setHomeworkSnapshot({
            subjects: 0,
            total: 0,
            notSubmitted: 0,
            forEvaluation: 0,
            returned: 0,
            dueToday: 0,
            overdue: 0,
         });
      }
   };

   const navigateToSubjectTab = (tab) => {
      if (o2o_mode === 'offline') return;
      navigate('/subject', { state: { activetab: tab } });
   };

   const renderLessonCard = (item) => {
      const count = parseInt(item.count);
      const hasItems = count > 0;

      return (
         <article
            className={`home-dashboard-resource-card is-${item.tone}`}
            key={item.title}
         >
            <div className="home-dashboard-resource-art">
               <img src={item.image} alt="" />
            </div>
            <div className="home-dashboard-resource-body">
               <div className="home-dashboard-card-heading">
                  <span className="home-dashboard-card-icon">{item.icon}</span>
                  <span className="home-dashboard-card-title">
                     {item.title}
                  </span>
               </div>

               {hasItems ? (
                  <button
                     type="button"
                     className="home-dashboard-resource-link"
                     disabled={o2o_mode === 'offline'}
                     onClick={() => navigateToSubjectTab(item.tab)}
                  >
                     <span>
                        <b>{item.count}</b> {item.label}
                     </span>
                     {o2o_mode !== 'offline' && <ArrowRightOutlined />}
                  </button>
               ) : (
                  <p className="home-dashboard-card-empty">
                     <Text>None</Text>
                  </p>
               )}
            </div>
         </article>
      );
   };

   const heroDescription = showStudentLiveClass
      ? 'Keep track of lessons, assessments, and Brainee Live Class activity in one focused workspace.'
      : 'Keep track of lessons and assessments in one focused workspace.';

   const resourcesTitle = showStudentLiveClass
      ? 'Lessons and Brainee Live Class'
      : role === 'Student'
        ? 'My Lessons'
        : 'Lesson Resources';

   return (
      <>
         <div className="dashboard-area-all home-dashboard-page">
            <div className="dashboard-item home-dashboard">
               {/* <div className="home-dashboard-breadcrumb">
                  <span className="home-dashboard-breadcrumb-label">Home</span>
               </div> */}

               <section
                  className="home-dashboard-hero"
                  style={{ marginTop: '15px' }}
               >
                  <div className="home-dashboard-hero-copy">
                     <Text className="home-dashboard-kicker">Brainee LMS</Text>
                     <h1>Welcome back, {displayName}</h1>
                     <p>{heroDescription}</p>
                     <p>
                        Together we evolve from offline to online learning,
                        adapt to the new normal, and transition from traditional
                        to non-traditional learning.
                     </p>
                     <div className="home-dashboard-hero-actions">
                        {showStudentLiveClass && (
                           <Button
                              shape="round"
                              className="home-dashboard-secondary-action"
                              icon={
                                 <ReloadOutlined
                                    spin={checkingStudentLiveClassRooms}
                                 />
                              }
                              onClick={getStudentLiveClassStatus}
                           >
                              Check Brainee Live Class
                           </Button>
                        )}
                     </div>
                  </div>
                  <div className="home-dashboard-hero-media" aria-hidden="true">
                     <img src="images/10.png" alt="" />
                  </div>
               </section>

               {role === 'Parent' ? (
                  <section className="home-dashboard-panel">
                     <Text className="home-dashboard-section-label">
                        Overview
                     </Text>
                     <h2 className="home-dashboard-section-title">
                        No dashboard resources are available for this role.
                     </h2>
                  </section>
               ) : (
                  <>
                     <section className="home-dashboard-panel">
                        <div className="home-dashboard-section-header">
                           <div>
                              <Text className="home-dashboard-section-label">
                                 My Resources
                              </Text>
                              <h2 className="home-dashboard-section-title">
                                 {resourcesTitle}
                              </h2>
                           </div>
                        </div>

                        <div className="home-dashboard-resource-grid">
                           {lessonCards.map(renderLessonCard)}

                           <article className="home-dashboard-resource-card is-past">
                              <div className="home-dashboard-resource-art">
                                 <img src="images/13.png" alt="" />
                              </div>
                              <div className="home-dashboard-resource-body">
                                 {renderPastLessonOrLiveClass()}
                              </div>
                           </article>
                        </div>
                     </section>

                     <section className="home-dashboard-panel">
                        <div className="home-dashboard-section-header">
                           <div>
                              <Text className="home-dashboard-section-label">
                                 Homework & Project Snapshot
                              </Text>
                              <h2 className="home-dashboard-section-title">
                                 Homeworks & Projects
                              </h2>
                           </div>
                        </div>

                        <div className="home-dashboard-assessment-grid">
                           {homeworkProjectSnapshotCards.map((item) => {
                              const cardCount = Number.parseInt(item.count, 10);
                              const isCountCard = Number.isFinite(cardCount);
                              const disabled =
                                 o2o_mode === 'offline' ||
                                 (isCountCard && cardCount <= 0);

                              return (
                                 <button
                                    type="button"
                                    className="home-dashboard-assessment-card"
                                    key={item.title}
                                    disabled={disabled}
                                    onClick={item.onClick}
                                 >
                                    <span className="home-dashboard-assessment-icon">
                                       {item.icon}
                                    </span>
                                    <span className="home-dashboard-assessment-copy">
                                       <span>{item.title}</span>
                                       <b>{item.count}</b>
                                    </span>
                                 </button>
                              );
                           })}
                        </div>
                     </section>
                  </>
               )}
            </div>
         </div>

         <Modal
            key="Modal-AI"
            // title="brAInee Bot"
            title={
               <>
                  <Image
                     src="../images/brainee_bot.png"
                     preview={false}
                     height="30px"
                  />
                  &nbsp;Brainee Bot
               </>
            }
            destroyOnClose={true}
            centered
            open={visibleAI}
            okButtonProps={{ style: { display: 'none' } }}
            onCancel={() => setVisibleAI(false)}
            cancelText="Close"
            width={isMobile ? '90%' : '65%'}
         >
            <ChatGPT persistDaily />
         </Modal>

         {/* {
            o2o_mode !== "offline" && !visibleAI &&
            <div className="chat-gpt-floating-button"
               onClick={() => setVisibleAI(true)}
            />
         } */}
         {!visibleAI && !['Parent', 'Student'].includes(role) && (
            <div
               className="chat-gpt-floating-button"
               onClick={() => setVisibleAI(true)}
            />
         )}
      </>
   );
}

export default Dashboard;
